import { render, staticRenderFns } from "./PremiumTable.vue?vue&type=template&id=0aaab052&scoped=true"
import script from "./PremiumTable.vue?vue&type=script&lang=js"
export * from "./PremiumTable.vue?vue&type=script&lang=js"
import style0 from "./PremiumTable.vue?vue&type=style&index=0&id=0aaab052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaab052",
  null
  
)

export default component.exports